export default from './NatureOfSuitTooltip'


// WEBPACK FOOTER //
// ./src/components/search/FormElements/tooltips/NatureOfSuitTooltip/index.js